import { Dialog, DialogContent, Button, Typography, Box } from "@mui/material";
import * as React from "react";

function AuthCodePopup(props) {
  const { openAuthCodePopup, handleAuthCodePopup, authCode } = props;

  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);

  const handleCopy = () => {
    const codeText = authCode; // Match screenshot default
    navigator.clipboard.writeText(codeText).then(() => {
      setShowSuccessMessage(true);
      // Hide the success message after 2 seconds
      setTimeout(() => {
        setShowSuccessMessage(false);
        handleAuthCodePopup(); // Close the popup after copying
      }, 2000);
    });
  };

  return (
    <Dialog
      open={openAuthCodePopup}
      fullWidth={true}
      maxWidth="xs"
      PaperProps={{
        style: {
          borderRadius: 12,
          backgroundColor: "#e6e9f0",
          // padding: "20px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <DialogContent padding={0}>
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <Box
            component="span"
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              // backgroundColor: "#f9c74f",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              border: "1px solid black",
            }}
            onClick={handleAuthCodePopup}
          >
            <Typography
              variant="body2"
              sx={{
                // color: "#4a4a4a",
                fontSize: "28px",
                // fontWeight: 600,
                lineHeight: 0,
              }}
            >
              ×
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: "1.2rem",
            color: "#333",
            textAlign: "center",
            marginBottom: "15px",
          }}
        >
          Authentication Code
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontSize: "16px",
            color: "#333",
            textAlign: "center",
            marginBottom: "15px",
          }}
        >
          Please copy the code below to authenticate and sign your documents on the following screens.
          <br />For additional details, refer to the instructions <a href="https://bondstreetmortgage.atlassian.net/wiki/external/MWNkYmJkZDlkNWQwNDg0ZDk5YTlhNzJlZmMyMzljOWU" target="_blank" rel="noopener noreferrer">here</a>
        </Typography>
        <Box
          sx={{
            border: "2px dashed #6b48ff",
            borderRadius: 4,
            backgroundColor: "#fff",
            padding: "8px 12px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            marginBottom: "20px",
            cursor: "pointer"
          }}
          onClick={handleCopy}
        >
          {/* <Typography
            variant="body1"
            sx={{
              fontSize: "1rem",
              color: "#555",
              marginRight: "8px",
            }}
          >
            ✂️
          </Typography> */}
          <Typography
            variant="body1"
            sx={{
              fontSize: "1rem",
              color: "#333",
              flexGrow: 1,
              textAlign: "center",
            }}
          >
            {authCode}
          </Typography>
          <Button
            variant="contained"
            sx={{
              padding: "6px 12px",
              fontSize: "0.875rem",
              fontWeight: 500,
              backgroundColor: "#6b48ff",
              color: "#fff",
              borderRadius: 4,
              "&:hover": {
                backgroundColor: "#5a3de6",
              },
              minWidth: "60px",
            }}
          >
            Copy
          </Button>
        </Box>
        {showSuccessMessage && (
          <Typography
            variant="body2"
            sx={{
              color: "green",
              fontSize: "0.875rem",
              textAlign: "center",
              marginTop: "10px",
            }}
          >
            Code copied to clipboard!
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default AuthCodePopup;